import React, { useEffect, useMemo, useState } from 'react';
import HomeIntroHeroSwiper from '../Components/Home/HomeIntroHero';
import HomeServicesSection from '../Components/Home/HomeServicesSection';
import HomeFeaturedProductsSection from '../Components/Home/HomeFeaturedProductsSection';
import HomeAboutSection from '../Components/Home/HomeAboutSection';
import CardPlaceholder from '../Components/UILibrary/CardPlaceholder';
import { HomeService } from '../../Logic/HomeService';
import type { IProductCardProps } from '@model/Products.model';
import HomeNewsletterForm from '../Components/Home/HomeNewsletterForm';
import UnauthorizedPopup from '../Components/Modals/UnauthorizedPopup';

const HomePage: React.FC = () => {
  const homeService = useMemo(() => new HomeService(), []);

  const [featuredProducts, setFeaturedProducts] = useState<IProductCardProps[]>([]);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);

  const slides = homeService.getHomeIntroSlides();
  const services = homeService.getHomeServices();
  const trustedBrands = homeService.getTrustedBrands();

  useEffect(() => {
    homeService
      .handleGetFeaturedProducts({
        limit: 7,
        setLoading,
        setApiError,
        setItems: setFeaturedProducts,
      })
      .catch(() => {});
  }, []);

  return (
    <main data-testid="home-page">
      <UnauthorizedPopup />
      <HomeIntroHeroSwiper slides={slides} />
      <HomeServicesSection services={services} />

      {loading && (
        <div>
          <CardPlaceholder count={4} />
        </div>
      )}

      {!loading && !apiError && featuredProducts.length > 0 && (
        <HomeFeaturedProductsSection products={featuredProducts} />
      )}
      <HomeAboutSection brands={trustedBrands} />
      <HomeNewsletterForm />
    </main>
  );
};

export default HomePage;
